/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRepresentantDoublonGridDto } from './FcbRepresentantDoublonGridDto';
import {
    FcbRepresentantDoublonGridDtoFromJSON,
    FcbRepresentantDoublonGridDtoFromJSONTyped,
    FcbRepresentantDoublonGridDtoToJSON,
} from './FcbRepresentantDoublonGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRepresentantDoublonGridDtoPaginatedResults
 */
export interface FcbRepresentantDoublonGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRepresentantDoublonGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRepresentantDoublonGridDto>}
     * @memberof FcbRepresentantDoublonGridDtoPaginatedResults
     */
    results?: Array<FcbRepresentantDoublonGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRepresentantDoublonGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRepresentantDoublonGridDtoPaginatedResults interface.
 */
export function instanceOfFcbRepresentantDoublonGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRepresentantDoublonGridDtoPaginatedResultsFromJSON(json: any): FcbRepresentantDoublonGridDtoPaginatedResults {
    return FcbRepresentantDoublonGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRepresentantDoublonGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRepresentantDoublonGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRepresentantDoublonGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRepresentantDoublonGridDtoPaginatedResultsToJSON(value?: FcbRepresentantDoublonGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRepresentantDoublonGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

